import React from "react";
import HowWeHelp from "../components/HowWeHelp";
import ContactUsHero from "../components/ContactUsHero";
import ContactForm from "../components/ContactForm";

const ContactUsPage = () => {
    return (
        <div>
            <ContactUsHero/>
            <ContactForm/>
            <HowWeHelp />
        </div>
    );
};

export default ContactUsPage;
